import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFound from './pages/NotFound/NotFound';
import Home from './pages/Home/Home';
import { RecoilRoot } from 'recoil';
import CurrentShoppingList from './pages/CurrentShoppingList/CurrentShoppingList';
import ManageLists from './pages/ManageLists/ManageLists';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';

function App() {
  return (
    <>
      <RecoilRoot>

        <BrowserRouter >
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='*' element={<NotFound />} />
            <Route path='/compra-da-vez/:id' element={<CurrentShoppingList />} />
            
            <Route path='/minhas-listas' element={<ManageLists />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
          </Routes>

        </BrowserRouter>

      </RecoilRoot>
    </>
  );
}

export default App;
